<template>
  <!-- 盒子/饰品升级--保底饰品（升级） -->
  <div class="upgrade_guaranteed_goods-box">
    <!-- header头部 -->
    <header>
      <el-form :inline="true" class="demo-form-inline">
        <el-form-item>
          <el-button type="primary" size="small" @click="openDialog(1)">添加保底物品</el-button>
        </el-form-item>
      </el-form>
    </header>
    <!-- body内容 -->
    <div class="body-box">
      <el-table :data="dataList" v-loading="loading" style="margin-bottom: 20px">
        <el-table-column prop="origin_name" label="名称" align="center">
        </el-table-column>
        <el-table-column prop="origin_image" label="图片" align="center">
          <template slot-scope="{ row }">
            <img style="width:100px" :src="row.origin_image" alt="">
          </template>
        </el-table-column>
        <el-table-column prop="origin_price" label="价格" align="center">
        </el-table-column>
        <el-table-column prop="action" label="操作" fixed="right" align="center">
          <template slot-scope="{ row }">
            <el-button type="danger" size="small" @click="handleDelete(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination background :page-size="dataMeta.per_page || 15" :total="dataMeta.total || 0"
        :current-page="dataMeta.current_page" @current-change="handlePageChange"
        v-if="dataMeta && dataMeta.total > dataMeta.per_page"></el-pagination>
    </div>

    <!-- 弹窗 -->
    <!-- 添加保底物品 -->
    <GuaranteedGoodsDialog v-model="dialogInfos" :visible="addGoodsVisible" :type="dialogType"
      @close="addGoodsVisible = false" @refresh="getData()"></GuaranteedGoodsDialog>
  </div>
</template>
<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import http, { server, api, delApiData, getApiData, postApiData, patchApiData } from '@/http'
import saveFile from '@/utils/saveFile'
import GuaranteedGoodsDialog from './component/GuaranteedGoodsDialog.vue'

export default {
  components: {
    GuaranteedGoodsDialog,
  },
  data() {
    return {
      addGoodsVisible: false,//添加物品弹窗显示标志
      loading: false,//加载动画
      query: {
        page: 1,
      },
      dataList: undefined,//数据列表
      dialogType: 1,//1是添加 2是修改 默认是1
      dialogInfos: undefined,//传给弹窗的数据
      dataMeta: undefined,//底部跳转页面条
    }
  },
  created() {
    this.getData()//获取数据列表
  },
  methods: {
    getData() {
      this.loading = true
      let params = this.query
      getApiData('upgrade_bottom_list', params)
        .then(res => {
          this.dataList = res.data
          //设置底部导航条数据
          this.dataMeta = res
        })
        .finally(() => {
          this.loading = false
        })
    },
    openDialog(num, val) {
      //打开添加队伍弹窗
      this.addGoodsVisible = true
      if (num === 1) {
        this.dialogType = 1
        this.dialogInfos = undefined
      }
      if (num === 2) {
        this.dialogType = 2
        this.dialogInfos = JSON.parse(JSON.stringify(val))
      }
    },
    handleDelete(rowInfo) {
      //删除
      this.$confirm('确定要删除吗？', {
        type: 'warning'
      }).then(res => {
        let params = {
          id: rowInfo.id,
          status: 0,
        }
        patchApiData(`upgrade_bottom`, params).then(res => {
          this.$message.success('删除成功')
          this.getData()
        })
      })
    },
    handlePageChange(page) {
      //页面底部跳转页面
      this.query.page = page
      this.getData(1);
    },
  }
}
</script>
<style lang="less" scoped>
.formula-box {
  display: flex;
  // justify-content: center;
  align-items: center;
  font-size: 12px;

  .goods-info {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .debris-info-item {
    margin-right: 5px;

    .debris-info {
      .debris-img {
        border: 2px solid rgb(105, 202, 25);
        width: 50px;
        height: 50px;
        display: flex;
        justify-content: center;
        align-items: center;
        overflow: hidden;

        img {
          width: 100%;
        }
      }
    }
  }
}
</style>